// eslint-disable-next-line import/prefer-default-export
export var FIELD_TYPES_USING_LEGEND = ["checkbox"];